import { render, staticRenderFns } from "./LoginAsUserButton.vue?vue&type=template&id=2f802290&scoped=true&"
import script from "./LoginAsUserButton.vue?vue&type=script&lang=ts&"
export * from "./LoginAsUserButton.vue?vue&type=script&lang=ts&"
import style0 from "./LoginAsUserButton.vue?vue&type=style&index=0&id=2f802290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f802290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f802290')) {
      api.createRecord('2f802290', component.options)
    } else {
      api.reload('2f802290', component.options)
    }
    module.hot.accept("./LoginAsUserButton.vue?vue&type=template&id=2f802290&scoped=true&", function () {
      api.rerender('2f802290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoginAsUserButton.vue"
export default component.exports